import { useSelector } from 'react-redux'

import LoadingIndicator from '../ReusableComponents/LoadingIndicator'

const FullScreenReloading = () => {
  const { isAppReloading } = useSelector(s => s.login)

  return (
    <>
      {isAppReloading ? (
        <div className="full-screen-loading">
          <LoadingIndicator />
        </div>
      ) : null}
    </>
  )
}

export default FullScreenReloading
